"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmall = function IconSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M36.384 9.577C28.71 2.984 17.18 3.557 10.2 10.94c-7.066 7.474-6.9 19.214.372 26.487s19.013 7.438 26.487.372c7.475-7.066 7.97-18.796 1.117-26.466l-1.492 1.332.245.28c5.874 6.866 5.354 17.164-1.244 23.4-6.687 6.323-17.191 6.175-23.699-.332-6.507-6.508-6.655-17.012-.333-23.7s16.818-7.13 23.68-.998l1.333-1.492zM27.3 20.09l1.08-2.3a9.7 9.7 0 0 0-4.03-.94c-2.63 0-4.09 1.36-4.09 3.5a4.27 4.27 0 0 0 2.18 3.62l2.22 1.59.035.024c.868.615 1.365.967 1.365 1.786 0 .83-.65 1.4-1.95 1.4a7.56 7.56 0 0 1-3.72-1.2l-1.12 2.3a9.1 9.1 0 0 0 4.76 1.34c2.89 0 4.7-1.4 4.7-4 0-1.74-.83-2.88-2.36-3.88l-2.38-1.67c-.75-.54-1.06-.81-1.06-1.42s.44-1 1.44-1a6.6 6.6 0 0 1 2.93.85",
    clipRule: "evenodd"
  })));
};

export { IconSmall, IconSmall as default };
